export const getTypeIcon = (type: string) => {
  switch (type) {
    case "text":
      return "text";
    case "textarea":
      return "paragraph";
    case "email":
      return "envelope";
    case "datetime_range":
      return "calendars";
    case "date_range":
      return "calendars";
    case "phone":
      return "phone";
    case "identification":
      return "id-card";
    case "number":
      return "hashtag";
    case "boolean":
      return "toggle-large-on";
    case "datetime":
      return "calendar";
    case "date":
      return "calendar";
    case "file":
      return "file-arrow-up";
    case "select":
      return "list";
    case "switch":
      return "toggle-on";
    default:
      return "question";
  }
};

export const getTypeRepresentation = (type: string) => {
  switch (type) {
    case "text":
      return "Texto";
    case "textarea":
      return "Área de texto";
    case "email":
      return "Correo electrónico";
    case "datetime_range":
      return "rango de fechas";
    case "date_range":
      return "rango de fechas";
    case "phone":
      return "Teléfono";
    case "identification":
      return "Identificación";
    case "number":
      return "Campo Numerico";
    case "datetime":
      return "Fecha y hora";
    case "date":
      return "Fecha";
    case "file":
      return "Archivo";
    case "select":
      return "Lista desplegable";
    case "switch":
      return "Booleano";
    default:
      return "desconocido";
  }
};

export const getLogicalOperatorName = (operator: string) => {
  switch (operator) {
    case "and":
      return "And";
    case "or":
      return "Or";
    case "not":
      return "Not";
    default:
      return "Desconocido";
  }
};
